import { Messages } from '~src/codegen/Localize';
import { ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { WorkbookAccelerations } from '~src/dataAcceleration/resources/WorkbookAccelerations';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { WorkbookAccelerationContentType } from '~src/spacesPlatform/models/ContentTypes';

import { getNoDefaultFilters } from '../../contentDefinitions/getDefaultFilters';

export const WorkbookAccelerationDefinition: ExplorableItemDefinition = {
  itemType: 'workbookAcceleration',
  pluralName: Messages.workbookAccelerations,
  singularName: Messages.workbookAcceleration,
  emptyStateMessage: Messages.workbookAccelerationsEmptyMessage,
  contentFilterKeys: WorkbookAccelerationContentType.filterKeys,
  defaultFilters: getNoDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => {
    return WorkbookAccelerations.all().withExtraParams(WorkbookAccelerationContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list']
};
